<template lang="pug">
  .component-parking-group.inner-content
    .row
      .column
        .label PG {{item.id}}
        .field-value {{item.name}}
</template>

<script>
  export default {
    name: 'ParkingGroup',
    props: ['item']
  }
</script>

<style lang="sass">
  .component-parking-group
    width: 100%

</style>



// WEBPACK FOOTER //
// ParkingGroup.vue?31e45f0e